'use client';

import { useId } from 'react';
import { cn } from '@packages/shared/src/utils/cn/cn';
import { Notification } from '../Notification/Notification';

export type RadioProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  error?: boolean;
  errorMessage?: string;
  labelClassName?: string;
};

const Radio = ({
  label,
  value,
  checked,
  error,
  errorMessage,
  disabled,
  onChange,
  id,
  labelClassName,
  ...props
}: RadioProps) => {
  const fallBackId = useId();
  return (
    <div className={`group ${error ? 'radio-error' : ''} ${disabled ? 'input-disabled' : ''}`}>
      <label
        htmlFor={id ?? fallBackId}
        className="flex cursor-pointer items-center group-[.input-disabled]:cursor-default"
      >
        <input
          id={id ?? fallBackId}
          type="radio"
          value={value}
          checked={checked}
          onChange={onChange}
          className="group-[.radio-error]:border-color-error border-color-grey-dark bg-color-background-base before:bg-color-text-dark m-1 grid h-2 w-2 -translate-y-[0.075em] cursor-pointer appearance-none place-content-center rounded-full border group-[.input-disabled]:cursor-default group-[.input-disabled]:opacity-35 group-[.radio-error]:border-2 before:h-1 before:w-1 before:scale-0 before:rounded-full before:transition-transform checked:before:scale-100"
          {...props}
        />
        <span
          className={cn('text-size-body-sm group-[.input-disabled]:opacity-35', labelClassName)}
        >
          {label}
        </span>
      </label>
      {error && errorMessage && (
        <Notification severity="error" variant="feedback" className="mt-0.5">
          {errorMessage}
        </Notification>
      )}
    </div>
  );
};

Radio.displayName = 'Radio';

export { Radio };
